/**
 * AUTO-GENERATED by scripts/generate-api-client.mjs — do not edit.
 * Regenerate: npm run generate:api
 */

import { apiClient } from '../ApiClient.js';
import { createContractClient } from '../createContractClient.js';
import { opsGatewayHealthContract } from '@cnapse/shared/api/contracts.js';

export const opsGatewayHealthApi = createContractClient(apiClient, opsGatewayHealthContract);
